/**
 * Commonly used libraries and functions.
 * Consult AG before making updates.
 */

/*=============================
=          Libraries          =
=============================*/

window.Cookies = require('js-cookie');
window.Velocity = require('velocity-animate');

require('waypoints/lib/noframework.waypoints.min.js');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.Promise = require('promise-polyfill').default;

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

var token = document.head.querySelector('meta[name="csrf-token"]');

if(token)
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
else
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');

/*=============================
=          Initialize         =
=============================*/

window.body = document.body;
window.hero = document.getElementById('hero');
window.main = document.querySelector('main');
window.footer = document.getElementById('footer');
window.header = document.getElementById('header');
window.headerHeight = 0
window.topbar = document.getElementById('topbar');
window.topbarHeight = topbar ? topbar.offsetHeight : 0;
window.navwrap = document.getElementById('nav-wrap');
window.menuContainer = document.getElementById('menu-container');

/*=============================
=      Check Window Width     =
=============================*/

/**
 * Checks if the parameter is less than the current window width.
 * @param {number} width - The intended window width.
 * @returns {boolean}
 */
window.checkWidth = function checkWidth(width) {
	return window.innerWidth < width;
};

/*=============================
=        Keyboard Focus       =
=============================*/

/**
 * Adds class .tabbing on "Tab" keyboard click.
 * Adds outline to <a> and <button> elements for ADA.
 */
document.addEventListener('keydown', function(e) {
	if(e.keyCode == 9 && !body.classList.contains('tabbing')) {
		body.classList.add('tabbing');
	}
});

document.addEventListener('mousedown', function() {
	if(body.classList.contains('tabbing')) {
		body.classList.remove('tabbing');
	}
});

/*=============================
=       Lazyload Scripts      =
=============================*/

/**
 * Lazy-load JavaScripts using Waypoints.
 * @param {HTMLElement} el - The intended DOM element.
 * @param {string} src - The JavaScript URL.
 * @param {string|number} offset - Trigger when the element is X from the top.
 */
window.scriptWaypoint = function scriptWaypoint(el, src, offset) {
	var scriptWaypoint = new Waypoint({
		element: el,
		handler: function(direction) {
			addJS(src);

			this.destroy();
		},
		offset: offset
	});
};

/**
 * Append JavaScripts to the <body>.
 * @param {string} src - The JavaScript URL.
 */
window.addJS = function addJS(src) {
	var script = document.createElement('script');

	script.src = src;
	script.type = 'text/javascript';
	script.setAttribute('async', 'true');
	script.setAttribute('defer', 'true');

	document.body.appendChild(script);
};

/*=============================
=       Scroll To Element     =
=============================*/

/**
 * Scrolls the page to an element.
 * @param {HTMLElement} scrollTo - The intended DOM element.
 */
window.scrollToElement = function scrollToElement(scrollTo) {
	if(scrollTo) {
		Velocity(scrollTo, 'scroll', {duration: 800, offset: -(headerHeight)});
	}
};

/*=============================
=           Set Focus         =
=============================*/

/**
 * Removes focus() on elements when a modal is open.
 * @param {boolean} open - Whether or not a modal is open.
 * @param {HTMLElement|boolean} container - Exclude the given DOM parent element.
 */
window.setFocus = function setFocus(open, container) {
	[].slice.call(document.querySelectorAll('#header, #hero, #main, #footer')).forEach(function(parent) {
		if(parent != container) {
			parent.setAttribute('aria-hidden', open);

			[].slice.call(parent.querySelectorAll('a, button, input')).forEach(function(link) {
				if(open) {
					link.setAttribute('tabindex', '-1');
				} else {
					link.removeAttribute('tabindex');
				}
			});
		}
	});
};

/*=============================
=        Skip to Content      =
=============================*/

/**
 * Scrolls to intended section on .skip-link click.
 * First <a> or <button> element of intended section receives focus().
 */
[].slice.call(document.querySelectorAll('.skip-link')).forEach(function(skipLink) {
	skipLink.addEventListener('click', function(e) {
		e.preventDefault();

		var selectors = {
				'#menu': '#menu > li > *:first-child',
				'#main': '#hero a, main a',
				'#footer': '#footer a'
			},
			firstLink = document.querySelector(selectors[this.getAttribute('href')]);

		if(firstLink) {
			scrollToElement(firstLink);
			firstLink.focus();
		}
	});
});

/**
 * Hides the .skip-link elements when a modal is open.
 * @param {boolean} hide - Whether or not to hide the .skip-link elements.
 */
window.skipLinkToggleDisplay = function skipLinkToggleDisplay(hide) {
	[].slice.call(document.querySelectorAll('.skip-link')).forEach(function(skipLink) {
		skipLink.style.display = hide ? 'none' : '';
	});
};

/*=============================
=           Slugify           =
=============================*/

/**
 * Converts a string into a slug.
 * @param {string} str
 * @returns {string}
 */
window.slugify = function slugify(str) {
	return String(str)
		.replace(/\s+/g, '-') // replace spaces with hyphens
		.replace(/-+/g, '-') // remove consecutive hyphens
		.trim() // trim leading or trailing whitespace
		.normalize('NFKD') // split accented characters into their base characters and diacritical marks
		.replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
		.toLowerCase() // convert to lowercase
		.replace(/[^a-z0-9 -]/g, ''); // remove non-alphanumeric characters
};

/*=============================
=          Get Domain         =
=============================*/

window.domain = getDomain();

function getDomain() {
	var domain = '',
		host = location.host,
		splitDomain = location.host.split('.');

	if(splitDomain.length >= 2) {
		domain = host;

		if(!host.includes('ivhost1')) {
			domain = host.replace(splitDomain[0]+(splitDomain.length == 2 ? splitDomain[1] : ''), '');
		}
	}

	return domain;
}

/*=============================
=       Google Map Styles     =
=============================*/

// window.mapStyles = [
// ];